import Slider from 'rc-slider'
import styles from './Slider.module.css'
import 'rc-slider/assets/index.css'
import { getSliderMarks } from '../../utils/slider'
import { useSwiper } from 'swiper/react'
import { CSSProperties, FC, useEffect, useState } from 'react'

interface QuestionSliderProps {
  labels: string[]
  onChange: (value: number) => void
  sliderValue?: number
  labelStyle?: CSSProperties
}

const QuestionSlider: FC<QuestionSliderProps> = ({
  labels,
  onChange,
  sliderValue = 0,
  labelStyle = {},
}) => {
  const [value, setValue] = useState<number>(sliderValue)

  useEffect(() => {
    setValue(sliderValue)
  }, [sliderValue])

  const swiper = useSwiper()

  const handleSliderAfterChange = (value: number) => {
    onChange(value)
  }

  const isStepsSliderStyle = labels.length > 2
  const trackColor = isStepsSliderStyle
    ? 'var(--track-bg-color)'
    : 'var(--color-background-accent)'
  const marks = getSliderMarks(labels, labelStyle)

  return (
    <>
      {!isStepsSliderStyle && (
        <div className={styles.sliderValue}>{value}%</div>
      )}
      <div className={styles.sliderWrapper}>
        {/* hacky hack to get the rounded corners, because left and right points overflow the standard rounded corners */}
        <div className={styles.roundedLeft} />
        <Slider
          min={0}
          max={isStepsSliderStyle ? labels.length - 1 : 100}
          value={value}
          marks={marks}
          step={isStepsSliderStyle ? null : undefined}
          onChange={(value) => setValue(value as number)}
          onBeforeChange={() => {
            if (swiper) {
              swiper.allowTouchMove = false
            }
          }}
          onAfterChange={(value) => {
            if (swiper) {
              swiper.allowTouchMove = true
            }
            handleSliderAfterChange(value as number)
          }}
          // TODO: add percentage labels as tooltip
          // handleRender={}
          trackStyle={{
            backgroundColor: trackColor,
            height: 19,
            top: -6,
            borderRadius: 0,
          }}
          railStyle={{
            backgroundColor: 'var(--track-bg-color)',
            height: 19,
            top: -6,
            borderRadius: 0,
          }}
          dotStyle={{
            backgroundColor: 'var(--dot-color)',
            border: 0,
            width: 15,
            height: 15,
          }}
          handleStyle={{
            border: '3px solid var(--color-black)',
            height: 40,
            width: 40,
            marginTop: -22,
            backgroundColor: 'white',
            boxShadow: 'none',
          }}
        />
        <div className={styles.roundedRight} />
      </div>
    </>
  )
}

export default QuestionSlider
